module.exports = __webpack_public_path__ + "150b2bf06ee350449c597727db85e11a.MP3";